import axios from "axios";

import { requestAuthInterceptor } from "./interceptors/requestAuth";
import { requestErrorInterceptor } from "./interceptors/requestError";
import { responseSuccessInterceptor } from "./interceptors/responseSuccess";
import { responseErrorInterceptor } from "./interceptors/responseError";
import { createInFlightRequestDedupAdapter } from "./interceptors/inFlightRequestDedup";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}/api/v1`,
  timeout: 20000,
  adapter: createInFlightRequestDedupAdapter(),
});

api.interceptors.request.use(
  requestAuthInterceptor,
  requestErrorInterceptor
);

api.interceptors.response.use(
  responseSuccessInterceptor,
  responseErrorInterceptor
);

export default api;
